import React from 'react'
import Dots from '../dots/Dots'
import useAppContext from '../../hook/useAppContext'
import './headerpage.css'

const HeaderPage = ({desc}) => {

      const {user, data} = useAppContext()
      const {personal} = user 

      const name = personal.name
      const dicebear = `https://api.dicebear.com/5.x/initials/svg?seed=${name}&fontSize=28`
      const avatar = personal.avatar.length === 0 ? dicebear : personal.avatar 
      const id_xat = personal.id_xat.length === 0 ? data.personal.id_xat : personal.id_xat 

      return (
            <div className="header_page__content flex">
                  <div className="header_page__user flex">
                        <div className="page_user__avatar flex">
                              <img src={avatar} alt={name} />
                        </div>
                        <div className="page_user__data flex">
                              <strong>{name}</strong>
                              <span>{id_xat}</span>
                              <p>{desc}</p>
                        </div>
                  </div>
                  <Dots />
            </div>
      )
}

export default HeaderPage
